const FormRoutes = {
    path: '/',
    component: () => import('@/layouts/blank/BlankLayout.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        {
            path: '/staffing/warning/:id',
            component: () => import('@/views/Staffing/EmployeeWarningFormView.vue'),
            props: true,
        },
        {
            path: '/payroll/advance-salary/:id',
            component: () => import('@/views/Payroll/SalaryAdvance/StaffAdvanceSalaryFormView.vue'),
            props: true
        },
    ]
};

export default FormRoutes;